import React, { useState, useEffect } from 'react'
import { AddwithWhiteCircle, UpdatePencil } from '../AllSvg'
import { Modal } from 'react-bootstrap'
import axios from 'axios';
import { toast } from 'react-toastify';
import { handleErrorToast } from '../CustomFunctions';
import { BASE_URL } from '../../config/axios';


const AddSubActivity = ({getSubActivity}) => {

    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false)

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [formData, setFormData] = useState({
        subactivity_code: '',
        subactivity_name: ''
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const validateform = () => {
        const newErrors = {};
        const requiredFields = [
            "subactivity_code",
            "subactivity_name",
        ]


        requiredFields.forEach((field) => {
            if (!formData[field]?.trim()) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }

        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {
                let res = await axios.post(`${BASE_URL}/detail-design/subactivity/`, formData)
                if (res.status === 201 || res.status === 200) {
                    setShow(false)
                    setFormData({ subactivity_code: '', subactivity_name: '' });
                    getSubActivity();
                } else { }

            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    }

    return (
        <>
            <button
                title="Add Detail Design"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Sub-Activity
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Add Sub-Activtiy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form">
                        <div className="form-flex-wrap">
                            <div title="Sub-Activity code" className="flex-column">
                                <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
                                    Sub-Activity code <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="subactivity_code"
                                    name="subactivity_code"
                                    placeholder="Sub-activity code"
                                    onChange={handleInputChange}
                                    value={formData.subactivity_code}
                                    className={`form-input ${errors.subactivity_code ? "input-error" : ""}`}
                                    style={{ width: '28vw' }}
                                />
                                {errors.subactivity_code && (
                                    <span className="error-message font-size-text ">{errors.subactivity_code}</span>
                                )}
                            </div>

                            <div title="Sub_activity" className="flex-column">
                                <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
                                    Sub-Activity Name <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="subactivity_name"
                                    name="subactivity_name"
                                    placeholder="Sub-Activity name"
                                    onChange={handleInputChange}
                                    value={formData.subactivity_name}
                                    className={`form-input ${errors.subactivity_name ? "input-error" : ""}`}
                                    style={{ width: '28vw' }}
                                />
                                {errors.subactivity_name && (
                                    <span className="error-message font-size-text ">{errors.subactivity_name}</span>
                                )}
                            </div>

                            <div className="button-models" style={{ width: '100%' }}>
                                <button
                                    onClick={handleFormSubmit}
                                    className="model-button   font-weight500    model-button-submit"                              >

                                    Add
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}



const UpdateSubActivity = ({ i, getSubActivity }) => {
    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState({
        id: '',
        subactivity_code: '',
        subactivity_name: ''
    });

    const handleShow = () => setShow(true);

    const handleClose = () => {
        setShow(false);
        setFormData({
            id: '',
            subactivity_code: '',
            subactivity_name: ''
        });
        setErrors({});
    };

    // Pre-fill form data when editing
    useEffect(() => {
        if (i) {
            setFormData({
                id: i.id || '',
                subactivity_code: i.subactivity_code || '',
                subactivity_name: i.subactivity_name || ''
            });
        }
    }, [i]);

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const validateForm = () => {
        let newErrors = {};
        if (!formData.subactivity_code) newErrors.subactivity_code = "Sub-activity code is required";
        if (!formData.subactivity_name) newErrors.subactivity_name = "Sub-activity name is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            let res = await axios.put(
                `${BASE_URL}/detail-design/subactivityupdate/${i.id}/`,
                formData
            );

            if (res.status === 200 || res.status === 201) {
                toast.success("Sub-activity updated successfully!");
                setShow(false);
                getSubActivity(); // refresh list
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave" restoreFocus={false} >
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>Update Sub-Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form" onSubmit={handleFormSubmit}>
                        <div className="form-flex-wrap">
                            {/* Sub-Activity Code */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Sub-Activity Code <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="subactivity_code"
                                    name="subactivity_code"
                                    placeholder="Sub-activity code"
                                    onChange={handleInputChange}
                                    value={formData.subactivity_code}
                                    className={`form-input ${errors.subactivity_code ? 'input-error' : ''}`}
                                    style={{ width: '28vw' }}
                                />
                                {errors.subactivity_code && (
                                    <span className="error-message">{errors.subactivity_code}</span>
                                )}
                            </div>

                            {/* Sub-Activity Name */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Sub-Activity Name <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="subactivity_name"
                                    name="subactivity_name"
                                    placeholder="Sub-Activity name"
                                    onChange={handleInputChange}
                                    value={formData.subactivity_name}
                                    className={`form-input ${errors.subactivity_name ? 'input-error' : ''}`}
                                    style={{ width: '28vw' }}
                                />
                                {errors.subactivity_name && (
                                    <span className="error-message">{errors.subactivity_name}</span>
                                )}
                            </div>

                            {/* Submit Button */}
                            <div className="button-models" style={{ width: '100%' }}>
                                <button type="submit" className="model-button font-weight500 model-button-submit">
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};


const DeleteSubActivity = ({ i, getSubActivity }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true)
    }

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/detail-design/subactivityupdate/${i.id}/`
            );

            if (res.status === 200) {
                toast.success(`${i.division_name} deleted successfully`);
                await getSubActivity(); // refresh table
                setShow(false);
            }
        } catch (err) {
            toast.error("Failed to delete division");
            console.error(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Sub-Activity: {i.subactivity_name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete{" "}
                        <strong>{i.subactivity_name}</strong>?
                    </p>
                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel"
                            onClick={() => setShow(false)}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export { AddSubActivity, UpdateSubActivity, DeleteSubActivity }
